import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState: any = {
    userInfo: {}
}

export const getUserInfo = createAsyncThunk('user/getUserInfo', async () => {
    return await axios.get(process.env.REACT_APP_AUTH_API + "/api/user/getCurrentUserInfo")
});

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        updateUserInfo: (state, action) => {
            state.userInfo = action.payload
        }
    },
    extraReducers: builder => {
        builder.addCase(getUserInfo.pending, state => {
        })
        builder.addCase(getUserInfo.fulfilled, (state, action: any) => {
            if (action.payload.data.code === 200) {                
                state.userInfo = action.payload.data.result
            }
        })
        builder.addCase(getUserInfo.rejected, (state, action: any) => {
            state.userInfo = {}
        })
    },
});

export default userSlice.reducer
export const { updateUserInfo } = userSlice.actions